<template>
    <div
        class="flex flex-col border-t border-gray-200 mt-1 pt-4 | first:pt-2 first:mt-0 first:border-transparent"
        data-testid="select-option-group"
    >
        <span
            class="px-3 pb-2 uppercase tracking-wider text-gray-600"
            :class="oldFontScale ? 'text-sm' : 'text-xs'"
            data-testid="option-group-label"
            v-text="label"
            v-if="label"
        />
        <slot />
    </div>
</template>

<script lang="ts" setup>
    import { inject } from 'vue';

    defineProps<{
        label: string;
    }>();

    const oldFontScale = inject<boolean>('oldFontScale', true);
</script>
